import React from 'react';
import { PiCheckCircleFill } from "react-icons/pi";
import { FaUserTie, FaChartLine } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import { GiReceiveMoney } from "react-icons/gi";

interface ScenarioTemplateCardProps {
  value: string;
  iconName: string;
  title: string;
  desc: string;
  curKey: string;
  sk: (value: string) => void;
}

// 图标映射表
const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  FaUserTie,
  MdManageAccounts,
  HiUserGroup,
  FaChartLine,
  GiReceiveMoney
};

const ScenarioTemplateCard: React.FC<ScenarioTemplateCardProps> = ({
  value,
  iconName,
  title,
  desc,
  curKey,
  sk
}) => {
  const isSelect = value === curKey;
  const IconComponent = iconMap[iconName] || FaUserTie; // 默认使用 FaUserTie

  return (
    <div 
      className={`card bg-[#F6F7FC] rounded-3xl w-56 shadow-sm mt-1 ${isSelect ? "shadow-2xl" : ""}
        transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-102 hover:shadow-xl
        relative font-inter cursor-pointer`}
      onClick={() => sk(value)}
    >
      <div className="card-body p-4">
        <div className="w-8 h-8 bg-[#242630] rounded-full p-2 flex items-center justify-center">
          <IconComponent className="text-white text-base" />
        </div>
        <div className="text-[16px] text-[#242630]">{title}</div>
        <div className="text-[14px] text-[#242630] mt-[-8px] opacity-60">{desc}</div>
      </div>
      {isSelect && (
        <div className="absolute bottom-[-4px] right-[-4px] rounded-full">
          <PiCheckCircleFill className="text-2xl text-[#4B5563]" />
        </div>
      )}
    </div>
  );
};

export default ScenarioTemplateCard;
